import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import { parseDateInput } from '@app/core/date/date-time.util';

/**
 * チャットアプリ風の日時表示パイプ
 *
 * - 今日: "14:30"
 * - 昨日: "昨日 14:30"
 * - 今年内: "3/5 14:30"
 * - 去年以前: "2025/3/5 14:30"
 */
@Pipe({
  name: 'chatDate',
  pure: true,
})
export class ChatDatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private readonly localeId: string) {}

  transform(value: string | number | Date | null | undefined): string {
    if (value == null) {
      return '';
    }

    const parsed = parseDateInput(value);
    if (!parsed) {
      return '';
    }

    const target = dayjs(parsed);
    if (!target.isValid()) {
      return '';
    }

    const now = dayjs();

    if (target.isSame(now, 'day')) {
      return target.format('HH:mm');
    }

    if (target.isSame(now.subtract(1, 'day'), 'day')) {
      const isEnglish = (this.localeId || '').toLowerCase().startsWith('en');
      return isEnglish
        ? `Yesterday ${target.format('HH:mm')}`
        : `昨日 ${target.format('HH:mm')}`;
    }

    if (target.isSame(now, 'year')) {
      return target.format('M/D HH:mm');
    }

    return target.format('YYYY/M/D HH:mm');
  }
}
